import avatar from "./images/avatar.png";
import logo from "./images/mtn-logo.png";
import logoDark from "./images/mtn-dark-logo.png";

export const images = {
  avatar,
  logo,
  logoDark,
};
